import React from 'react';
import ControlPlaneLayout from './ControlPlaneLayout';

const ProvidersPage = () => {
  return (
    <ControlPlaneLayout
      eyebrow="Providers Page"
      title="Provider agents"
      description="Review the providers participating in request markets, their calibration history, and domain-specific reputation."
    />
  );
};

export default ProvidersPage;
